import React from 'react'

type ViewContextValue = {
	selectedRestaurantId: string | null
	setSelectedRestaurantId: (id: string | null) => void
}

const ViewContext = React.createContext<ViewContextValue>({
	selectedRestaurantId: null,
	setSelectedRestaurantId: () => {},
})

// Die Auswahl übersteht einen Reload; fehlt das gemerkte Restaurant in der Liste, wählt
// RestaurantsView wie gehabt den Default.
const SELECTED_RESTAURANT_STORAGE_KEY = 'selectedRestaurantId'

export const ViewProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
	const [selectedRestaurantId, setSelectedRestaurantId] = React.useState<string | null>(() => {
		try {
			return localStorage.getItem(SELECTED_RESTAURANT_STORAGE_KEY)
		} catch {
			return null
		}
	})

	React.useEffect(() => {
		try {
			if (selectedRestaurantId) {
				localStorage.setItem(SELECTED_RESTAURANT_STORAGE_KEY, selectedRestaurantId)
			} else {
				localStorage.removeItem(SELECTED_RESTAURANT_STORAGE_KEY)
			}
		} catch {
			// Ohne Speicher (etwa im privaten Modus) bleibt es beim Default nach dem Reload.
		}
	}, [selectedRestaurantId])

	const value = React.useMemo(
		() => ({
			selectedRestaurantId,
			setSelectedRestaurantId,
		}),
		[selectedRestaurantId]
	)
	return <ViewContext.Provider value={value}>{children}</ViewContext.Provider>
}

export const useView = () => React.useContext(ViewContext)
